<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex"
import moment from "moment";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Monthly Sales Analysis Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,
  },
  data() {
    return {
      total_amount: 0,
      total_paid: 0,
      filterSales: {
        // month: this.currentdate.getMonth(),
        month: moment().month(),
        year: moment().year(),
        branch_id: 0
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Monthly Sales Analysis Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Monthly Sales Analysis Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      monthfields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "month",
          sortable: true,
          label: 'MONTH',
        },
        {
          key: "date",
          sortable: true,
          label: 'DATE',
        },
        {
          key: "amount",
          sortable: true,
          label: 'TOTAL SALES',
        },
        {
          key: "details",
          sortable: true,
          label: "DETAILS",
        }
      ],
      Months: [
        { id: 12, text: "All Months" },
        { id: 0, text: "January" },
        { id: 1, text: "February" },
        { id: 2, text: "March" },
        { id: 3, text: "April" },
        { id: 4, text: "May" },
        { id: 5, text: "June" },
        { id: 6, text: "July" },
        { id: 7, text: "August" },
        { id: 8, text: "September" },
        { id: 9, text: "October" },
        { id: 10, text: "November" },
        { id: 11, text: "December" },
      ],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("sales", ["filterStatus", "MonthlySalesAnalysis"]),
    ...mapGetters("users", ["Users"]),
    ...mapGetters("auth", ["business", "branch", "Branches"]),
    ...mapGetters("setting", ["GeneralSettings"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.MonthlySalesAnalysis ? this.MonthlySalesAnalysis.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.MonthlySalesAnalysis ? this.MonthlySalesAnalysis.length : 1;
  },
  methods: {
    ...mapActions({
      FetchMonthlySalesAnalysis: "sales/fetchMonthlySales",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchBranches: "auth/fetchBranches",
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    SalesAnalysisData() {
      this.FetchMonthlySalesAnalysis(this.filterSales);
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  updated() {
    let total_amount = 0;
    // let total_paid = 0;
    if (this.MonthlySalesAnalysis) {
      this.MonthlySalesAnalysis.forEach((item) => {
        total_amount = total_amount + parseInt(item.amount);
      });
      this.total_amount = total_amount;
    }
  },
  watch: {
    SalesAnalysis(newValue) {
      if (newValue == true) {
        this.SalesAnalysisData();
      }
    }
  },
  created() {
    this.SalesAnalysisData();
    this.FetchMonthlySalesAnalysis(this.filterSales);
    this.FetchGeneralSettings();
    this.FetchBranches();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center">Monthly Sales Analysis Report</h3>
              </div>
            </div>
            <div class="row" v-if="BranchData.BranchId == 0">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>

                <model-list-select :list="Branches ? [{ id: 0, name: 'All Branches' }, ...Branches] : []" v-model="filterSales.branch_id" option-value="id"
                  option-text="name" placeholder="Select Branch" @input="SalesAnalysisData()">
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 form-group">
                <label>MONTH</label>

                <model-list-select :list="Months ? Months : []" v-model="filterSales.month" option-value="id"
                  option-text="text" placeholder="Select Month" @input="SalesAnalysisData()">
                </model-list-select>
              </div>
              <div class="col-md-3 form-group">
                <label>YEAR</label>

                <input v-model="filterSales.year" placeholder="Enter Year" class="form-control"
                  @keyup.enter="SalesAnalysisData()" />
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="SalesAnalysisData()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="filterStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0" v-if="filterSales.month != 12">
              <b-table class="datatables" :items="MonthlySalesAnalysis ? MonthlySalesAnalysis : []" :fields="monthfields"
                responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc"
                :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(month)="">
                  <p v-if="filterSales.month == 0">{{ 'January' }}</p>
                  <p v-if="filterSales.month == 1">{{ 'February' }}</p>
                  <p v-if="filterSales.month == 2">{{ 'March' }}</p>
                  <p v-if="filterSales.month == 3">{{ 'April' }}</p>
                  <p v-if="filterSales.month == 4">{{ 'May' }}</p>
                  <p v-if="filterSales.month == 5">{{ 'June' }}</p>
                  <p v-if="filterSales.month == 6">{{ 'July' }}</p>
                  <p v-if="filterSales.month == 7">{{ 'August' }}</p>
                  <p v-if="filterSales.month == 8">{{ 'September' }}</p>
                  <p v-if="filterSales.month == 9">{{ 'October' }}</p>
                  <p v-if="filterSales.month == 10">{{ 'November' }}</p>
                  <p v-if="filterSales.month == 11">{{ 'December' }}</p>
                </template>
                <template #cell(amount)="data">
                  {{ thousandSeperator(data.item.amount) }}
                </template>
                <template #cell(details)="data">
                  <router-link :to="{
                    name: 'Monthly Sales Details',
                    params: { date: data.item.date, period: filterSales.month },
                  }">
                    <b-button variant="info" class="btn btn-sm">Details</b-button>
                  </router-link>
                </template>
              </b-table>
              <div class="row">

                <div class="col-md-4"></div>
                <div class="col-md-4">
                  <h5>Total Amount: <span class="text-danger">{{ thousandSeperator(total_amount) }}</span></h5>
                </div>
              </div>
            </div>
            <div v-else>
              <table class="table-responsive mb-0 table" align="center">
                <thead>
                  <tr>
                    <th>MONTH</th>
                    <th>TOTAL SALES</th>
                    <th>DETAILS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="MonthlySalesAnalysis.jansales != 0">
                    <td>January</td>
                    <td>{{ MonthlySalesAnalysis.jansales }}</td>
                    <td>
                      <router-link :to="{
                        name: 'Monthly Sales Details',
                        params: { date: 1, period: filterSales.month },
                      }">
                        <b-button variant="info" class="btn btn-sm">Details</b-button>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="MonthlySalesAnalysis.febsales != 0">
                    <td>February</td>
                    <td>{{ MonthlySalesAnalysis.febsales }}</td>
                    <td>
                      <router-link :to="{
                        name: 'Monthly Sales Details',
                        params: { date: 2, period: filterSales.month },
                      }">
                        <b-button variant="info" class="btn btn-sm">Details</b-button>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="MonthlySalesAnalysis.marsales != 0">
                    <td>March</td>
                    <td>{{ MonthlySalesAnalysis.marsales }}</td>
                    <td>
                      <router-link :to="{
                        name: 'Monthly Sales Details',
                        params: { date: 3, period: filterSales.month },
                      }">
                        <b-button variant="info" class="btn btn-sm">Details</b-button>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="MonthlySalesAnalysis.aprsales != 0">
                    <td>April</td>
                    <td>{{ MonthlySalesAnalysis.aprsales }}</td>
                    <td>
                      <router-link :to="{
                        name: 'Monthly Sales Details',
                        params: { date: 4, period: filterSales.month },
                      }">
                        <b-button variant="info" class="btn btn-sm">Details</b-button>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="MonthlySalesAnalysis.maysales != 0">
                    <td>May</td>
                    <td>{{ MonthlySalesAnalysis.maysales }}</td>
                    <td>
                      <router-link :to="{
                        name: 'Monthly Sales Details',
                        params: { date: 5, period: filterSales.month },
                      }">
                        <b-button variant="info" class="btn btn-sm">Details</b-button>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="MonthlySalesAnalysis.junsales != 0">
                    <td>June</td>
                    <td>{{ MonthlySalesAnalysis.junsales }}</td>
                    <td>
                      <router-link :to="{
                        name: 'Monthly Sales Details',
                        params: { date: 6, period: filterSales.month },
                      }">
                        <b-button variant="info" class="btn btn-sm">Details</b-button>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="MonthlySalesAnalysis.julsales != 0">
                    <td>July</td>
                    <td>{{ MonthlySalesAnalysis.julsales }}</td>
                    <td>
                      <router-link :to="{
                        name: 'Monthly Sales Details',
                        params: { date: 7, period: filterSales.month },
                      }">
                        <b-button variant="info" class="btn btn-sm">Details</b-button>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="MonthlySalesAnalysis.augsales != 0">
                    <td>August</td>
                    <td>{{ MonthlySalesAnalysis.augsales }}</td>
                    <td>
                      <router-link :to="{
                        name: 'Monthly Sales Details',
                        params: { date: 8, period: filterSales.month },
                      }">
                        <b-button variant="info" class="btn btn-sm">Details</b-button>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="MonthlySalesAnalysis.sepsales != 0">
                    <td>September</td>
                    <td>{{ MonthlySalesAnalysis.sepsales }}</td>
                    <td>
                      <router-link :to="{
                        name: 'Monthly Sales Details',
                        params: { date: 9, period: filterSales.month },
                      }">
                        <b-button variant="info" class="btn btn-sm">Details</b-button>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="MonthlySalesAnalysis.octsales != 0">
                    <td>October</td>
                    <td>{{ MonthlySalesAnalysis.octsales }}</td>
                    <td>
                      <router-link :to="{
                        name: 'Monthly Sales Details',
                        params: { date: 10, period: filterSales.month },
                      }">
                        <b-button variant="info" class="btn btn-sm">Details</b-button>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="MonthlySalesAnalysis.novsales != 0">
                    <td>November</td>
                    <td>{{ MonthlySalesAnalysis.novsales }}</td>
                    <td>
                      <router-link :to="{
                        name: 'Monthly Sales Details',
                        params: { date: 11, period: filterSales.month },
                      }">
                        <b-button variant="info" class="btn btn-sm">Details</b-button>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="MonthlySalesAnalysis.decsales != 0">
                    <td>December</td>
                    <td>{{ MonthlySalesAnalysis.decsales }}</td>
                    <td>
                      <router-link :to="{
                        name: 'Monthly Sales Details',
                        params: { date: 12, period: filterSales.month },
                      }">
                        <b-button variant="info" class="btn btn-sm">Details</b-button>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
                <div class="row text-center">
                  <b>
                    <h5>Grand Total: {{ MonthlySalesAnalysis.totalsales }}</h5>
                  </b>
                </div>
              </table>
            </div>
            <Loader v-if="!MonthlySalesAnalysis" />
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}
</style>